export default __webpack_public_path__ + "static/media/D_007.85fe70d0.jpg";